module.exports = __webpack_public_path__ + "img/dankai_klaudia.170c0f31.jpg";